export const calculateDiscountPercentage = (listPrice: number, salesPrice: number): number => {
	return listPrice === 0 ? 0 : ((listPrice - salesPrice) / listPrice) * 100;
};
